import styled, { DefaultTheme } from 'styled-components';
import { DatePicker } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(
  props: { theme?: DefaultTheme },
  darkValue: T,
  lightValue: T
): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const StyledDateRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
  border-radius: 6px;
  
  .ant-picker-input > input {
    color: ${(props) => getThemeValue(props, '#ffffff', '#1A202C')};
  }
  
  .ant-picker-suffix {
    color: ${(props) => getThemeValue(props, '#CBD5E0', '#718096')};
  }
  
  .ant-picker-separator {
    color: ${(props) => getThemeValue(props, '#CBD5E0', '#718096')};
  }
  
  &:hover {
    border-color: ${(props) => getThemeValue(props, '#718096', '#CBD5E0')};
  }
  
  &.ant-picker-focused {
    border-color: ${(props) => getThemeValue(props, '#4299E1', '#1890ff')};
    box-shadow: ${(props) =>
      getThemeValue(
        props,
        '0 0 0 2px rgba(66, 153, 225, 0.2)',
        '0 0 0 2px rgba(24, 144, 255, 0.2)'
      )};
  }
`;

export const PickerContainer = styled.div`
  width: 100%;
  position: relative;
`;
